import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrJobcardAddPage } from './klmr-jobcard-add';

@NgModule({
  declarations: [
    KlmrJobcardAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrJobcardAddPage),
  ],
})
export class KlmrJobcardAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-jobcard-add/klmr-jobcard-add.module.ts